import React, { Component } from 'react';

// Components
import LockedOverlay from './LockedOverlay';

class FormContainer extends Component {

  render() {
    let { children, optionalClassName, isLocked } = this.props;

    return (
      <div className={`form-container${optionalClassName ? ' ' + optionalClassName : ''}`}>
        {children}
        {isLocked && <LockedOverlay/>}
      </div>
    );
  }
}

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/Global/FormContainer.js